// City + intent combinations used for local-search landing pages, e.g. /pune/flats-for-rent
export const CITIES = [
  { slug: "delhi-ncr", name: "Delhi NCR", query: { q: "Delhi" } },
  { slug: "noida", name: "Noida", query: { city: "Noida" } },
  { slug: "gurgaon", name: "Gurgaon", query: { city: "Gurgaon" } },
  { slug: "mumbai", name: "Mumbai", query: { city: "Mumbai" } },
  { slug: "pune", name: "Pune", query: { city: "Pune" } },
  { slug: "bengaluru", name: "Bengaluru", query: { city: "Bengaluru" } },
  { slug: "hyderabad", name: "Hyderabad", query: { city: "Hyderabad" } },
  { slug: "chennai", name: "Chennai", query: { city: "Chennai" } },
  { slug: "ahmedabad", name: "Ahmedabad", query: { city: "Ahmedabad" } },
  { slug: "kolkata", name: "Kolkata", query: { city: "Kolkata" } },
  { slug: "jaipur", name: "Jaipur", query: { city: "Jaipur" } },
  { slug: "agra", name: "Agra", query: { city: "Agra" } },
];

export const INTENTS = [
  { slug: "flats-for-rent", label: "Flats for rent", category: "rent", noun: "rental homes" },
  { slug: "flats-for-sale", label: "Flats for sale", category: "buy", noun: "homes for sale" },
  { slug: "pg-for-rent", label: "PG & co-living", category: "pg", noun: "PGs and co-living beds" },
  { slug: "commercial-property", label: "Commercial property", category: "commercial", noun: "offices and shops" },
  { slug: "plots-for-sale", label: "Plots & land", category: "plot", noun: "plots and land parcels" },
];

export const findCity = (slug) => CITIES.find((c) => c.slug === slug);
export const findIntent = (slug) => INTENTS.find((i) => i.slug === slug);
export const cityPath = (city, intent) => `/${city.slug}/${intent.slug}`;
